
<template>
  <div class="pdc-div">
    <div class="disFlex between" style="margin-top: 20px;" id="kyxd">
      <div class="pdc-bot-l">
        <el-tabs v-model="activeName">
          <el-tab-pane label="产品介绍" name="first">
            <img src="../assets/images/7.png" />
          </el-tab-pane>
          <el-tab-pane label="课程目类" name="second">
            <div class="pdc-bot-l-kcml" v-for="(item,i) in kclist">
              <div class="disFlex between">
                <div class="disFlex" style="align-items: center;">
                  <img style="width: 15px;height: 15px;" :src="item.active?imgUrl2:imgUrl1" />
                  <span :class="item.active?'activeKcTitle':'KcTitle'">{{i+1>9?i+1:'0'+(i+1)}}
                    这里是章节的标题这里是章节的标题这里是章节的标题<i class="el-icon-circle-check" v-if="!item.active" style="color: #0071BA;"></i></span>
                </div>
                <div class="disFlex" :style="item.active?'color:#0071BA;':''">{{item.active?'已学80%':'已学完'}}</div>
              </div>
              <div class="pdc-bot-l-kcml-jj">
                <span>主讲人：张老师</span>
                <span>课时：3</span>
                <span>时长：00:12:30</span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="课程附件" name="third">
            <div v-for="item in fjlist" class="disFlex" style="margin: 0 20px;border-bottom: 1px solid #dfdfdf;padding: 20px 0;">
              <div>
                <img v-if="item.type=='music'" src="../assets/images/file_music.png"/>
                <img v-if="item.type=='excel'" src="../assets/images/file_excel.png"/>
                <img v-if="item.type=='img'" src="../assets/images/file_img.png"/>
                <img v-if="item.type=='pdf'" src="../assets/images/file_pdf.png"/>
                <img v-if="item.type=='ppt'" src="../assets/images/file_ppt.png"/>
                <img v-if="item.type=='video'" src="../assets/images/file_video.png"/>
                <img v-if="item.type=='word'" src="../assets/images/file_word.png"/>
              </div>
              <div class="disFlex between" style="flex-direction: column;padding-left: 10px;text-align: left;font-size: 14px;">
                <div>革命性力量席卷全球.{{item.type}}</div>
                <div style="color: #999999;">2341人下载</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="评价" name="fourth">评价</el-tab-pane>
        </el-tabs>
      </div>
      <div class="pdc-bot-r">
        <h3>简介</h3>
        <div :style="isBuy?'border-bottom: 1px solid #efefef;':''">
          这里是一段产品的简介，业内名师，系统讲解大纲知识点，突出重难点，
          紧跟命题方向透彻解析教材。这里是一段产品的简介，业内名师，系统讲解大纲知识点，突出重难点，
          紧跟命题方向透彻解析教材。这里是一段产品的简介。这里是一段产品的简介，业内名师，系统讲解大纲知识点，
          突出重难点，紧跟命题方向透彻解析教材。
          这里是一段产品的简介，业内名师，系统讲解大纲知识点，突出重难点，紧跟命题方向透彻解析教材。这里是一段产品的简介。
        </div>
        <h3 v-if="isBuy" class="disFlex between">
          <span>课程</span><span class="kc-wcd">完成度：<span style="color: #0071BA;">23/26</span></span>
        </h3>
        <div v-if="isBuy" class="disFlex" style="flex-wrap: wrap;">
          <div v-for="(kecheng,k) in kclist" :class="kecheng.iskg?'pdc-bot-r-k-kc active':'pdc-bot-r-k-kc'"
            :style="k%7==6?'margin-right:0px!important;':(k%7==0?'margin-left:0px!important;':'')">
            {{k+1}}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    formatTime
  } from '../assets/js/common.js';
  import MyVideo from './common/MyVideo';
  export default {
    name: 'ProductDetail',
    data() {
      return {
        isBuy: true,
        isks: false,
        isFullpage: false,
        kclist: [{
          iskg: true,
          active: true
        }, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}],
        fjlist:[{type:'excel'},{type:'pdf'},{type:'video'},{type:'img'},{type:'word'},{type:'ppt'},{type:'music'}],
        activeName: 'first',
        videoSrc: 'http://192.168.0.108:8087/jtzy/16/zxkt/2021/6/10/b54856354d684857af9f9b13025f8fcc.mp4',
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        },
        imgUrl1: require("@/assets/images/hasPlay.png"),
        imgUrl2: require("@/assets/images/isPlay.png"),
        imgUrl3: require("@/assets/images/notPlay.png")
      }
    },
    methods: {
      parentChange: function(isFullpage) {
        this.isFullpage = isFullpage;
      },
      // 跳转订单信息页面
      toBuy: function() {
        this.$router.push('/Order')
      }
    },
    components: {
      MyVideo
    },
    created: function() {

    },
    mounted: function() {
      var mainContainer=document.getElementById('mainContainer');
      var kyxd=document.getElementById('kyxd');
      mainContainer.onscroll = function(){
        if(mainContainer.scrollTop>=640){
          this.$router.push('/Cpxd');
        }
      }
    },
  }
</script>

<style>
  .pdc-div {}

  /* 已购买的上面的样式 */
  .pdc-top-not {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    display: flex;

  }

  .pdc-top-not-l {
    width: 345px;
    height: 207px;
    opacity: 1;
    background: #e6e6e6;
    border-radius: 4px;
    margin-right: 24px;
  }

  .pdc-top-not-r-tit {
    font-size: 24px;
    font-family: "PingFang SC";
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 33px;
  }

  .pdc-top-not-r-jiage {
    font-size: 13px;
    font-family: "PingFang SC";
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
    margin: 27px 0 25px 0;
  }

  .pdc-top-not-r-price {
    width: 770px;
    height: 50px;
    opacity: 1;
    background: #f7f8fb;
    text-align: left;
    font-size: 30px;
    font-family: DINAlternate, DINAlternate-Bold;
    font-weight: 700;
    text-align: justify;
    color: #d50000;
    line-height: 50px;
    letter-spacing: 2px;
    padding-left: 20px;
    margin-bottom: 13px;
  }

  /* 为购买的上面的样式 */
  .pdc-top-yes {
    opacity: 1;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    padding: 20px;
  }

  .pdc-top-yes-v {
    height: calc(100% - 106px);
  }

  .pdc-top-yes-v-l {
    flex: 1.8;
    opacity: 0.6;
    background: #000000;
    position: relative;
  }

  .pdc-top-yes-v-r {
    width: 400px;
    opacity: 1;
    background: #000000;
    height: 100%;
    overflow: auto;
  }

  .pdc-top-yes-v-r::-webkit-scrollbar {
    width: 4px;
    height: 20px;
    opacity: 1;
    background: #232323;
    border-radius: 2px;
  }

  .pdc-top-yes-v-r::-webkit-scrollbar-thumb {
    background: #6a6969;
    border-radius: 2px;
  }

  .pdc-top-yes-v-r-kc {
    color: #9a9a9a;
    padding: 22px 0 18px 0px;
    margin: 0 18px;
    border-bottom: 1px solid #525252;
    font-size: 14px;
  }

  .pdc-top-yes-jj {
    opacity: 1;
    background: #333333;
    color: #fff;
    padding: 12px 40px 14px 28px;
    text-align: left;
  }

  .pdc-top-yes-jj-l {
    width: calc(100% - 400px - 68px);
    font-size: 20px;
    letter-spacing: 1px;
  }

  .pdc-top-yes-jj-l-time {
    margin-top: 8px;
    color: #dfdfdf;
    letter-spacing: 1px;
    font-size: 14px;
  }

  .pdc-top-yes-jj-r {
    padding-top: 15px;
  }

  .pdc-bot-l {
    background-color: #fff;
    width: 856px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    padding: 0 0 20px 0;
  }

  .pdc-bot-l .el-tabs__item {
    height: 58px;
    line-height: 58px;
    padding: 0 33px;
  }

  .pdc-bot-l .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding: 0 33px;
  }

  .pdc-bot-r {
    width: 326px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    text-align: left;
  }

  .pdc-bot-r h3 {
    margin: 15px 20px 0px 19px;
    font-size: 16px;
    color: #333333;
  }

  .pdc-bot-r h3 .kc-wcd {
    font-size: 12px;
    color: #9a9a9a;
  }

  .pdc-bot-r div {
    margin: 15px 18px 20px 18px;
    padding-bottom: 20px;
    color: #9a9a9a;
    font-size: 14px;
  }

  .pdc-bot-r-k-kc {
    width: 36px;
    height: 36px;
    opacity: 1;
    background: #efefef;
    border-radius: 1px;
    margin: 0px 6px 6px 0 !important;
    padding: 0 !important;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }

  .pdc-bot-r-k-kc.active {
    background: #def3e9;
    color: #0071BA;
  }

  .pdc-bot-l-kcml {
    padding: 20px 0 15px;
    margin: 0 20px;
    text-align: left;
    color: #9a9a9a;
    font-size: 14px;
    border-bottom: 1px solid #d8d8d8;
  }

  .pdc-bot-l-kcml .KcTitle {
    padding-left: 10px;
    font-weight: 500;
    font-size: 18px;
    color: #9a9a9a;
    letter-spacing: 1px;
    font-family: "PingFang SC";
  }

  .pdc-bot-l-kcml .activeKcTitle {
    padding-left: 10px;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 500;
    font-family: "PingFang SC";
    color: #0071BA;
  }
  .pdc-bot-l-kcml-jj{
    font-size: 14px;
    font-family: "PingFang SC";
    text-align: left;
    color: #9a9a9a;
    letter-spacing: 1px;
    padding: 10px 0 10px 25px;
  }
  .pdc-bot-l-kcml-jj span{
    padding-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cpxd.vue